import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  menus:any[] = [];
  selected:any[] = [];
  constructor(public auth:AuthService,private global:GlobalService) {
    this.menuClick = this.menuClick.bind(this);
  }

  ngOnInit() {
    this.global.isAuthenticated().then((res)=>{
      if(res){
        this.global.blockUI = true;
        this.global.loadAppAuth().then((res)=>{
          this.auth.user.apps.forEach(e => {
            let app:any = e;
            this.menus.push(app);
          });
          this.selected = Object.assign([],this.menus);
          this.global.blockUI = false;
        });
      }
    });
    
  }

  filterChange(e){
    let array:any[] = this.menus.filter(x=>x.appDesc.toString().toLowerCase().includes(e.event.target.value.toLowerCase()));
    this.selected = Object.assign([],array);
  }

  menuClick(d){
    console.log(d);
    this.menus[0].appUrl
    if (d.appUrl != null) {
      let baseUrl = window.location.href.toString().split('/')[0];
      window.open(baseUrl + '/' + d.appUrl, "_blank");
    }
  }

}
